import { load } from './lib/_load.js';
import { object } from './lib/_obj.js';
import { setting } from './lib/_setting.js';
import { listenHistory } from './lib/_history.js';

let $html = document.documentElement;
export let report = {
	init: function(type){
		if(type === "history"){
			listenHistory.init();
		}else{
			channel.init();
		}
	}
}
let channel = {
	jsonURL: "/jlc/listenplus/app/result_recommend_rank.json",
	currentYear: 0,
	data: {},
	filterData: [],
	currentData: [],
	init: function(){
		let now  = new Date();
		let year = now.getFullYear();
		this.currentYear = year;
		let apiURL = this.jsonURL;
		if(location.hostname.includes("kentaromi.tokyo") || location.hostname.includes("macbook-pro.local")){
			
		}else{
			apiURL = setting.channel;
		}
		load.getJson(apiURL, {}).then( (res) =>{
			//console.log("RANK:", channel.currentYear, res);
			channel.data = res.data.listening_data.program_result;
			if( res.data.listening_data.jme_member_id === ""){
				
			}else{
				
			}
			channel.filter();
		});
		document.querySelector("body").classList.remove("disable");
	},
	filter: function(){
		let obj = {
			year: 0,
			ranking: []
		}
		let before = 0;
		channel.filterData = [];
		let c;
		for(let i = 0; i < channel.data.length; i++){
			let d = channel.data[i];
			if( d.year != before ){
				if(i > 0){
					channel.filterData.push(c);
				}
				c = object(obj);
				c.year = d.year;
				c.ranking = [];
				c.ranking.push(d);
			}else{
				c.ranking.push(d);
			}
			if(i === channel.data.length - 1){
				channel.filterData.push(c);
			}
			before = d.year;
		}
		channel.makeRank();
	},
	makeRank: function(){
		let navHTML = "";
		
		for(let j = 0; j < channel.filterData.length; j++){
			//console.log(channel.currentYear, channel.filterData[j].year);
			if( channel.currentYear === parseInt(channel.filterData[j].year)){
				channel.currentData = channel.filterData[j];
				
				navHTML += `<option value="${channel.filterData[j].year}" selected>${channel.filterData[j].year}</option>`;
			}else{
				navHTML += `<option value="${channel.filterData[j].year}">${channel.filterData[j].year}</option>`;
			}
		}
		document.querySelector("select#select_year").innerHTML = navHTML;
		channel.nav();
		channel.currentData.ranking.sort((a, b) => a.rank - b.rank)
		let HTML3 = "";
		let HTML4 = "";
		for(let i = 0; i < channel.currentData.ranking.length; i++){
			let d = channel.currentData.ranking[i];
			if(i >= 0 && i < 3){
				HTML3 += channel.rank3(d);
			}else{
				HTML4 += channel.rank4(d);
			}
		}
		document.querySelector("ul#list0").innerHTML = HTML3;
		document.querySelector("ul#list1").innerHTML = HTML4;
	},
	nav: function(){
		let $select = document.querySelector("select#select_year");
		$select.removeEventListener("change", channel.changeYear, false);
		$select.addEventListener("change", channel.changeYear, false);
	},
	changeYear: function(){
		let year = parseInt( this.options[this.selectedIndex].value );
		channel.currentYear = year;
		window.scrollTo(0, 0);
		channel.makeRank();
	},
	rank3: function(d){
		let time = channel.calcTime(d.time);
		let title = ``;
		if(d.link && d.link != ""){
			title = `<h3><a href="${d.link}" target="_blank" rel="noopener"><span>${d.program_name}</span></a></h3>`;
		}else{
			title = `<h3><span>${d.program_name}</span></h3>`;
		}
		let onair = "";
		if(d.airtime && d.airtime != ""){
			onair = `<li><div class="icon"><svg role="img"><title>date</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/jlc/listenplus/app/assets/images/common/sprite.svg#icon_date"></use></svg></div><p>${d.airtime}</p>
			</li>`;
		}else{
			onair = ``;
		}
		let HTML 	= `<li class="c top3">
						<div class="inr">
							<div class="time">
								<dl>
									<dt>TOTAL</dt>
									<dd>${time}</dd>
								</dl>
							</div>
							<div class="content">
								<div class="cols">
									<div class="col_l">
										<figure><img src="${d.image}" alt="${d.program_name}"></figure>
									</div>
									<div class="col_r">
										${title}
										<div class="info">
											<ul>
												${onair}
												<li>
													<div class="icon"><svg role="img"><title>mic</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/jlc/listenplus/app/assets/images/common/sprite.svg#icon_mc"></use></svg></div>
													<p>${d.performer}</p>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<i class="rank"></i>
					</li>`;
		return HTML;
	},
	rank4: function(d){
		//console.log(d);
		let time = channel.calcTime(d.time);
		let title = ``;
		if(d.link && d.link != ""){
			title = `<h3><a href="${d.link}" target="_blank" rel="noopener"><span>${d.program_name}</span></a></h3>`;
		}else{
			title = `<h3><span>${d.program_name}</span></h3>`;
		}
		let HTML = `<li class="c other">
						<div class="inr">
							<div class="rank_num"><p>${d.rank}</p></div>
							<div class="content">
								${title}
								<div class="time">
									<div class="icon"><svg role="img"><title></title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/jlc/listenplus/app/assets/images/common/sprite.svg#icon_time"></use></svg></div>
									<dl>
										<dt>TOTAL</dt>
										<dd>${time}</dd>
									</dl>
								</div>
							</div>
						</div>
					</li>`;
		return HTML;
	},
	calcTime: function(time){
		let h = Math.floor(time/60);
		let m = time%60;
		return `${h}<span class="unit">h</span>${m}<span class="unit">m</span>`
	}
}